import React, {useState, useCallback} from 'react'
import ConfirmDialog from '../components/modal/ConfirmDialog'

interface ConfirmOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  variant?: 'danger' | 'warning' | 'primary'
}

const useConfirmDialog = () => {
  const [options, setOptions] = useState<ConfirmOptions | null>(null)
  const [resolver, setResolver] = useState<((value: boolean) => void) | null>(null)

  const confirm = useCallback((opts: ConfirmOptions): Promise<boolean> => {
    return new Promise((resolve) => {
      setOptions(opts)
      setResolver(() => resolve)
    })
  }, [])

  const handleConfirm = useCallback(() => {
    resolver?.(true)
    setOptions(null)
    setResolver(null)
  }, [resolver])

  const handleClose = useCallback(() => {
    resolver?.(false)
    setOptions(null)
    setResolver(null)
  }, [resolver])

  const dialogElement = options ? (
    <ConfirmDialog
      show={!!options}
      title={options.title}
      message={options.message}
      confirmText={options.confirmText}
      cancelText={options.cancelText}
      variant={options.variant}
      onConfirm={handleConfirm}
      onClose={handleClose}
    />
  ) : null

  return {confirm, dialogElement}
}

export default useConfirmDialog
